let nestedOverlayOpenCount = 0
let nestedOverlayCloseTimer: number | null = null

const PORTAL_OVERLAY_SELECTORS = [
  '[data-radix-select-viewport]',
  '[role="listbox"]',
  '[data-radix-popper-content-wrapper]',
  '[data-radix-menu-content]',
  '[data-radix-dropdown-menu-content]',
  '[class*="__menu-portal"]',
  '[class*="__menu"]',
] as const

export const registerNestedOverlayOpen = () => {
  if (nestedOverlayCloseTimer != null) {
    window.clearTimeout(nestedOverlayCloseTimer)
    nestedOverlayCloseTimer = null
  }
  nestedOverlayOpenCount += 1
}

export const registerNestedOverlayClose = () => {
  if (nestedOverlayCloseTimer != null) {
    window.clearTimeout(nestedOverlayCloseTimer)
  }

  // Select/Popover close before Dialog outside handlers run.
  nestedOverlayCloseTimer = window.setTimeout(() => {
    nestedOverlayOpenCount = Math.max(0, nestedOverlayOpenCount - 1)
    nestedOverlayCloseTimer = null
  }, 150)
}

export const isPortaledOverlayTarget = (
  target: EventTarget | null
): boolean => {
  if (!(target instanceof Element)) return false

  return PORTAL_OVERLAY_SELECTORS.some(selector => target.closest(selector))
}

export const shouldPreventDialogDismiss = (
  target: EventTarget | null
): boolean => nestedOverlayOpenCount > 0 || isPortaledOverlayTarget(target)

type DismissEvent = {
  preventDefault: () => void
  target: EventTarget | null
}

export const guardDialogDismiss = (event: DismissEvent) => {
  if (shouldPreventDialogDismiss(event.target)) {
    event.preventDefault()
  }
}
